import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { Alert, PasswordInput } from '../components/ui';
import './login.css';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (password !== confirmPassword) {
      return setError('Passwords do not match');
    }
    if (password.length < 6) {
      return setError('Password must be at least 6 characters');
    }

    setLoading(true);
    try {
      const res = await authAPI.resetPassword(token, { newPassword: password });
      setSuccess(true);
      setError(res.data.message || 'Password successfully reset.');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid or expired token.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__mesh">
        <div className="login-page__mesh-1" />
        <div className="login-page__mesh-2" />
        <div className="login-page__grid" />
      </div>

      <div className="login-page__container">
        <div className="login-page__brand">
          <div className="login-page__logo">P</div>
          <h1 className="login-page__title">ProjectHub</h1>
          <p className="login-page__tagline">Reset your password</p>
        </div>

        <div className="login-page__card">
          <h2 style={{ textAlign: 'center', marginBottom: '1.5rem', color: 'var(--text)' }}>Create New Password</h2>

          {error && <Alert type={success ? "success" : "error"} message={error} />}

          {!success && (
            <form onSubmit={handleSubmit}>
              <div className="login-page__field">
                <label className="login-page__label">New Password</label>
                <PasswordInput 
                  placeholder="••••••••" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  required 
                />
              </div>

              <div className="login-page__field">
                <label className="login-page__label">Confirm Password</label>
                <PasswordInput 
                  placeholder="••••••••" 
                  value={confirmPassword} 
                  onChange={(e) => setConfirmPassword(e.target.value)} 
                  required 
                />
              </div>

              <button type="submit" disabled={loading} className="login-page__submit">
                {loading ? 'Please wait...' : 'Reset Password'}
              </button>
            </form>
          )}

          {success && (
            <div style={{ textAlign: 'center', marginTop: '1rem' }}>
              <p style={{ color: 'var(--text-muted)' }}>Redirecting to login...</p>
              <button 
                onClick={() => navigate('/login')} 
                className="login-page__submit"
                style={{ marginTop: '1rem' }}
              >
                Go to Sign In
              </button>
            </div>
          )}

          {!success && (
            <div style={{ textAlign: 'center', marginTop: '1rem' }}>
              <button type="button" onClick={() => navigate('/login')} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '0.9rem' }}>
                Back to Sign In
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
